import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Loader2, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';
import '../../styles/vds-auth.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vds-auth-page">
      <div className="vds-auth-container">
        <div className="vds-auth-header">
          <Link to="/" className="vds-auth-logo">
            <div className="vds-auth-logo-mark">
              <Shield className="h-5 w-5" />
            </div>
            <span className="vds-auth-logo-text">VETT</span>
          </Link>
          <h1 className="vds-auth-title">Reset password</h1>
          <p className="vds-auth-subtitle">
            {sent ? 'Check your email' : "Enter your email and we'll send you a reset link"}
          </p>
        </div>

        <div className="vds-auth-card">
          {sent ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ 
                width: '64px', 
                height: '64px', 
                borderRadius: '16px', 
                background: 'rgba(0, 201, 167, 0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <CheckCircle className="w-8 h-8" style={{ color: '#00C9A7' }} />
              </div>
              <h2 style={{ 
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: '20px',
                fontWeight: 700,
                color: '#0A0F1E',
                marginBottom: '8px'
              }}>
                Check your inbox
              </h2>
              <p style={{ 
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: '14px',
                fontWeight: 600,
                color: '#5B6472',
                marginBottom: '24px',
                lineHeight: 1.6
              }}>
                If an account exists for <span style={{ color: '#0A0F1E' }}>{email}</span>, you&apos;ll receive a password reset link shortly.
              </p>
              <p style={{ 
                fontFamily: "'DM Mono', monospace",
                fontSize: '13px',
                color: '#5B6472'
              }}>
                Didn&apos;t receive it?{' '}
                <button
                  onClick={() => setSent(false)}
                  style={{ 
                    color: '#1B5AFF', 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer',
                    fontFamily: "'DM Mono', monospace",
                    fontSize: '13px'
                  }}
                >
                  Try again
                </button>
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="vds-auth-form">
              <div className="vds-form-group">
                <label className="vds-form-label" htmlFor="email">Email address</label>
                <div className="vds-input-wrapper">
                  <Mail className="vds-input-icon h-5 w-5" />
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="vds-input"
                    required
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="vds-btn-auth-primary"
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" />
                    Sending...
                  </>
                ) : (
                  'SEND RESET LINK'
                )}
              </button>
            </form>
          )}
        </div>

        <div className="vds-auth-footer">
          <Link 
            to="/login" 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '8px',
              color: '#5B6472',
              textDecoration: 'none',
              fontFamily: "'DM Mono', monospace",
              fontSize: '13px'
            }}
          >
            <ArrowLeft className="w-4 h-4" />
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
